// export const BASE_URL = process.env.REACT_APP_BASE_URL||"https://b.sbaaa.org/";
export const BASE_URL ="api/";
export const AUTH_URL ="auth/";



export const API_END_POINTS = {
  /////////////////////////////<===MUTATIONS===>//////////////////////////////
  registerBusinessForm: BASE_URL + "customer-forms",
  contactForm: BASE_URL + "contact-us",
  registerUser: AUTH_URL + "register", 
  loginUser: AUTH_URL + "login",
  /////////////////////////////<===QUERIES===>////////////////////////////////
  // getPackages: BASE_URL + "protected/user/myPackages",
};